document.addEventListener('DOMContentLoaded', () => {
  console.log('[app.js] DOM loaded');

  // Accessibility: respect reduced motion
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Real AJAX add-to-cart for global / sticky CTA + product pages
  async function addToCart(variantId, quantity = 1) {
    if (!variantId) return;

    const qty = Number(quantity) || 1;
    console.log('[app.js] Add to cart clicked', { variantId, quantity: qty });

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: qty,
        }),
      });

      if (!res.ok) throw new Error('Cart error');

      const data = await res.json();
      console.log('[app.js] Cart add success', data);

      // 🔹 UPDATE HEADER CART COUNT HERE
      const cartCountEls = document.querySelectorAll('[data-cart-count]');
      cartCountEls.forEach((el) => {
        const current = parseInt(el.textContent, 10) || 0;
        el.textContent = current + qty;
      });

      // 🔹 Flash all add-to-cart buttons (main + sticky + upsells)
      const btns = document.querySelectorAll(
        '.add-to-cart, #sticky-add, .fix8-upsell-add, [id^="fix8-add-to-cart-main-"]',
      );
      btns.forEach((b) => {
        if (!b) return;
        const original = b.dataset.labelOriginal || b.textContent || 'Add to Cart';
        if (!b.dataset.labelOriginal) {
          b.dataset.labelOriginal = original;
        }
        b.disabled = true;
        b.textContent = 'Added ✓';
        setTimeout(() => {
          b.disabled = false;
          b.textContent = b.dataset.labelOriginal;
        }, 1200);
      });

      // TODO: trigger cart drawer / mini-cart if your theme has one
      return data;
    } catch (e) {
      console.error('[app.js] Cart add error', e);
    }
  }

  //Mobile toggle menu

  // Fix8 mobile nav toggle
  const fix8Header = document.querySelector('.fix8-header');
  if (fix8Header) {
    const navToggle = fix8Header.querySelector('.nav-toggle');
    const navLinks = fix8Header.querySelector('.nav-links');

    if (navToggle && navLinks) {
      navToggle.addEventListener('click', () => {
        const isOpen = navLinks.classList.toggle('is-open');
        navToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }
  }

  // Bind package cards (only apply where structure matches)
  const cards = document.querySelectorAll('.card[data-sku]');
  console.log('[app.js] Cards found:', cards.length);

  cards.forEach((card) => {
    const btn = card.querySelector('.add-to-cart');
    if (!btn) return;

    btn.addEventListener('click', () => {
      const sku = card.dataset.sku || '';

      const stickySelect = document.getElementById('sticky-variant');
      if (stickySelect && sku) {
        stickySelect.value = sku;
      }

      addToCart(sku, 1);
    });
  });

  // Sticky bar interactions (safe if not present)
  const stickySelect = document.getElementById('sticky-variant');
  const stickyAdd = document.getElementById('sticky-add');

  console.log('[app.js] Sticky elements:', {
    stickySelect: !!stickySelect,
    stickyAdd: !!stickyAdd,
  });

  if (stickySelect && stickyAdd) {
    stickyAdd.addEventListener('click', async (e) => {
      e.preventDefault();

      const option = stickySelect.selectedOptions[0];
      if (!option) return;

      const variantId = option.value || option.dataset.variantId;
      const quantity = 1; // adjust if you add a qty control for the sticky bar

      await addToCart(variantId, quantity);

      // After adding to cart, go to basket
      window.location.href = '/cart';
    });
  }

  // Sticky CTA: stop above footer
  const stickyBar = document.querySelector('.sticky-bar');
  const footer = document.querySelector('footer');

  if (stickyBar && footer) {
    function updateStickyPosition() {
      const footerTop = footer.offsetTop;
      const viewportBottom = window.scrollY + window.innerHeight;

      const overlap = viewportBottom - footerTop;

      if (overlap > 0) {
        stickyBar.style.transform = `translateY(-${overlap}px)`;
      } else {
        stickyBar.style.transform = 'translateY(0)';
      }
    }

    updateStickyPosition();
    window.addEventListener('scroll', updateStickyPosition);
    window.addEventListener('resize', updateStickyPosition);
  }

  // Reveal animations
  if (!prefersReduced && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.animate(
              [
                { opacity: 0, transform: 'translateY(10px)' },
                { opacity: 1, transform: 'translateY(0)' },
              ],
              {
                duration: 500,
                easing: 'ease-out',
                fill: 'forwards',
              },
            );
            observer.unobserve(e.target);
          }
        });
      },
      { threshold: 0.1 },
    );

    const targets = document.querySelectorAll('.feature, .review, .card, .gallery img, details');
    console.log('[app.js] Anim targets:', targets.length);

    targets.forEach((el) => observer.observe(el));
  } else {
    console.log('[app.js] Animations disabled (prefersReduced or no IO)');
  }

  (function () {
    var grid = document.getElementById('fix8-products-grid');
    if (!grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('.product-card'));
    var filterButtons = document.querySelectorAll('.filter-bar [data-filter]');
    var sortSelect = document.getElementById('fix8-sort-select');

    if (!cards.length) return;

    // Filter by collection handle(s) in data-collections
    filterButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var filter = btn.getAttribute('data-filter');

        // Active state
        filterButtons.forEach(function (b) {
          b.classList.remove('active');
        });
        btn.classList.add('active');

        cards.forEach(function (card) {
          var collectionsAttr = card.getAttribute('data-collections') || '';
          var collections = collectionsAttr.split(' ').filter(Boolean); // ["kits", "buckets", ...]

          if (filter === 'all' || collections.indexOf(filter) !== -1) {
            card.style.display = '';
          } else {
            card.style.display = 'none';
          }
        });
      });
    });

    // Sort (unchanged, still uses data-price)
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var val = sortSelect.value;
        var visibleCards = cards.filter(function (c) {
          return c.style.display !== 'none';
        });

        visibleCards.sort(function (a, b) {
          var pa = parseFloat(a.getAttribute('data-price')) || 0;
          var pb = parseFloat(b.getAttribute('data-price')) || 0;

          if (val === 'price-asc') return pa - pb;
          if (val === 'price-desc') return pb - pa;
          return 0;
        });

        visibleCards.forEach(function (c) {
          grid.appendChild(c);
        });
      });
    }
  })();

  const sections = document.querySelectorAll('[id^="fix8-product-"]');
  if (!sections.length) return;

  sections.forEach((section) => {
    const sectionId = section.dataset.sectionId;

    /* ===== Gallery thumbs (added video support)===== */
    const mainMediaWrap = document.getElementById(`fix8-main-media-${sectionId}`);
    const thumbsWrap = document.getElementById(`fix8-thumbs-${sectionId}`);

    if (mainMediaWrap && thumbsWrap) {
      thumbsWrap.querySelectorAll('.thumb').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          thumbsWrap.querySelectorAll('.thumb').forEach((t) => t.classList.remove('active'));
          thumb.classList.add('active');

          const mediaHtml = thumb.dataset.mediaHtml;
          if (mediaHtml) {
            mainMediaWrap.innerHTML = mediaHtml;
          }
        });
      });
    }

    /* ===== Variant & price sync ===== */
    const variantSelect = document.getElementById(`fix8-variant-select-${sectionId}`);
    const stickyVariantSelect = document.getElementById(`fix8-sticky-variant-${sectionId}`);
    const hiddenVariantInput = document.getElementById(`fix8-hidden-variant-id-${sectionId}`);
    const priceMain = document.getElementById(`fix8-price-main-${sectionId}`);
    const priceCompare = document.getElementById(`fix8-price-compare-${sectionId}`);
    const stickyPrice = document.getElementById(`fix8-sticky-price-${sectionId}`);
    const stickyVariantLabel = document.getElementById(`fix8-sticky-variant-label-${sectionId}`);
    const addToCartMain = document.getElementById(`fix8-add-to-cart-main-${sectionId}`);
    const stickyAdd = document.getElementById(`fix8-sticky-add-${sectionId}`);

    function applyVariantUI(optionEl, variantId = null) {
      if (!optionEl) return;

      const price = optionEl.dataset.price || '';
      const compare = optionEl.dataset.compare || '';
      const title = optionEl.dataset.title || optionEl.textContent.trim();

      if (priceMain) priceMain.textContent = price;
      if (stickyPrice) stickyPrice.textContent = price;
      if (priceCompare) priceCompare.textContent = compare || '';

      if (stickyVariantLabel) stickyVariantLabel.textContent = title;

      if (hiddenVariantInput && variantId) {
        hiddenVariantInput.value = variantId;
      }

      const disabled = optionEl.disabled;
      if (addToCartMain) addToCartMain.disabled = disabled;
      if (stickyAdd) stickyAdd.disabled = disabled;
    }

    if (variantSelect) {
      applyVariantUI(variantSelect.selectedOptions[0], variantSelect.value);

      variantSelect.addEventListener('change', () => {
        const opt = variantSelect.selectedOptions[0];
        applyVariantUI(opt, variantSelect.value);

        if (stickyVariantSelect) {
          stickyVariantSelect.value = opt.value;
        }
      });
    }

    if (stickyVariantSelect) {
      if (stickyVariantSelect.tagName === 'SELECT') {
        stickyVariantSelect.addEventListener('change', () => {
          const opt = stickyVariantSelect.selectedOptions[0];
          applyVariantUI(opt, stickyVariantSelect.value);

          if (variantSelect) {
            variantSelect.value = stickyVariantSelect.value;
          }
        });
      }
    }

    /* ===== Quantity controls ===== */
    const qtyDisplay = document.getElementById(`fix8-qty-display-${sectionId}`);
    const qtyInput = document.getElementById(`fix8-qty-input-${sectionId}`);
    const qtyControls = section.querySelector('.qty-controls[data-section-id="' + sectionId + '"]');

    if (qtyDisplay && qtyInput && qtyControls) {
      qtyControls.querySelectorAll('.qty-btn').forEach((btn) => {
        btn.addEventListener('click', () => {
          const step = parseInt(btn.dataset.step, 10) || 0;
          let qty = parseInt(qtyDisplay.textContent, 10) || 1;
          qty += step;
          if (qty < 1) qty = 1;
          qtyDisplay.textContent = qty;
          qtyInput.value = qty;
        });
      });
    }

    /* ===== AJAX Add to Cart helpers - Removing duplicate MR ===== */
    // async function addToCart(variantId, quantity = 1) {
    //   if (!variantId) return;
    //   try {
    //     const res = await fetch('/cart/add.js', {
    //       method: 'POST',
    //       headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    //       body: JSON.stringify({ id: Number(variantId), quantity: Number(quantity) }),
    //     });
    //     if (!res.ok) throw new Error('Cart error');
    //     return await res.json();
    //   } catch (e) {
    //     console.error(e);
    //   }
    // }

    function flashButton(btn) {
      if (!btn) return;
      const original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Added ✓';
      setTimeout(() => {
        btn.disabled = false;
        btn.textContent = original;
      }, 900);
    }

    /* Main add to cart (uses form values) */
    if (addToCartMain) {
      addToCartMain.addEventListener('click', async (e) => {
        const form = document.getElementById(`fix8-product-form-${sectionId}`);
        if (!form) return;

        e.preventDefault();

        const formData = new FormData(form);
        const variantId = formData.get('id');
        const quantity = formData.get('quantity') || 1;

        const result = await addToCart(variantId, quantity);

        if (result) {
          flashButton(addToCartMain);
        } else {
          console.warn('[main add] Add to cart failed', { sectionId, variantId, quantity });
        }
      });
    }

    /* Sticky add to cart */
    if (stickyAdd) {
      stickyAdd.addEventListener('click', async () => {
        let variantId = null;

        if (stickyVariantSelect) {
          variantId = stickyVariantSelect.value;
        } else if (variantSelect) {
          variantId = variantSelect.value;
        } else if (hiddenVariantInput) {
          variantId = hiddenVariantInput.value;
        }

        const quantity = qtyInput ? qtyInput.value : 1;

        if (!variantId) {
          console.warn('[sticky add] No variant ID found', { sectionId });
          return;
        }

        const result = await addToCart(variantId, quantity);

        if (result) {
          flashButton(stickyAdd);
        } else {
          console.warn('[sticky add] Add to cart failed', { sectionId, variantId, quantity });
        }
      });
    }

    /* Buy Now → add to cart then go to checkout */
    const buyNowBtn = document.getElementById(`fix8-buy-now-${sectionId}`);
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', async () => {
        const form = document.getElementById(`fix8-product-form-${sectionId}`);
        if (!form) return;

        const formData = new FormData(form);
        const variantId = formData.get('id');
        const quantity = formData.get('quantity') || 1;

        const result = await addToCart(variantId, quantity);

        if (result) {
          window.location.href = '/checkout';
        } else {
          console.warn('[buy now] Add to cart failed', { sectionId, variantId, quantity });
        }
      });
    }

    /* Upsell add-to-cart */
    section
      .closest('body')
      .querySelectorAll('.fix8-upsell-add')
      .forEach((btn) => {
        btn.addEventListener('click', async () => {
          const variantId = btn.dataset.variantId;
          if (!variantId) return;

          const result = await addToCart(variantId, 1);

          if (result) {
            flashButton(btn);
          } else {
            console.warn('[upsell add] Add to cart failed', { variantId });
          }
        });
      });
    /* Tabs */
    const tabsWrap = document.getElementById(`fix8-tabs-${sectionId}`);
    if (tabsWrap) {
      const tabButtons = tabsWrap.querySelectorAll('.tab-btn');
      tabButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          const targetId = btn.dataset.tab;
          if (!targetId) return;
          tabButtons.forEach((b) => b.classList.remove('active'));
          btn.classList.add('active');
          tabsWrap.querySelectorAll('.tab-panel').forEach((panel) => {
            panel.classList.toggle('active', panel.id === `tab-${targetId}`);
          });
        });
      });
    }
  });

  // Smooth scroll for anchor links on this page (if any)
  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', (e) => {
      const id = link.getAttribute('href').slice(1);
      if (!id) return;
      const el = document.getElementById(id);
      if (!el) return;
      e.preventDefault();
      window.scrollTo({ top: el.offsetTop - 80, behavior: 'smooth' });
    });
  });

  // Namespaced Sticky CTA logic for About page
  (function () {
    const cta = document.getElementById('fix8-about-cta');
    const footer = document.querySelector('.fix8-about-footer');
    if (!cta || !footer) return;

    function onScroll() {
      const scrollY = window.scrollY || window.pageYOffset;
      const viewportH = window.innerHeight || document.documentElement.clientHeight;

      if (scrollY > viewportH * 0.6) {
        cta.classList.add('visible');
      } else {
        cta.classList.remove('visible');
      }

      const footerRect = footer.getBoundingClientRect();
      const ctaHeight = cta.offsetHeight || 0;
      const wouldOverlapFooter = footerRect.top < viewportH - ctaHeight;

      if (wouldOverlapFooter) {
        cta.classList.add('at-footer');
      } else {
        cta.classList.remove('at-footer');
      }
    }

    window.addEventListener('scroll', onScroll);
    window.addEventListener('resize', onScroll);
    document.addEventListener('DOMContentLoaded', onScroll);
  })();
});
